import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CheckEmailStatusBindingModel, CheckEmailStatusViewModel, Customer, LogoutViewModel, SendMigrationLinkBindingModel, SendMigrationLinkViewModel, SendEmailVerificationBindingModel, SendEmailVerificationViewModel, SendPasswordResetKeyLinkToEmailBindingModel, SendPasswordResetKeyLinkToEmailViewModel, IsValidPasswordResetKeyBindingModel, IsValidPasswordResetKeyViewModel, ResetPasswordBindingModel, ResetPasswordViewModel, RegisterCustomerBindingModel, UpdateDetailsBindingModel, UpdateDetailsViewModel, ChangePasswordBindingModel, SetPasswordViewModel, CustomerTransactionBindingModel, CustomerTransaction, IsValidMigrationKeyBindingModel, IsValidMigrationKeyViewModel, MigrateCustomerBindingModel, MigrateCustomerViewModel, UpdateCustomerBindingModel, UpdateCustomerViewModel, IsValidEmailVerificationKeyBindingModel, IsValidEmailVerificationkeyViewModel, VerifyCustomerEmailBindingModel, VerifyCustomerEmailViewModel, State, Country, Branch, CancelPendingTransactionBindingModel, ComputeOrderBindingModel, ComputeOrderViewModel, PlaceOrderBindingModel, PlaceOrderViewModel, ValidateGiftVoucherByNumberBindingModel, VerifyPendingTransactionBindingModel, CommitPaymentBindingModel, CommitPaymentViewModel, SetTransactionAsPaidOnlineBindingModel, SendTransactionToEmailBindingModel, DownloadGiftVoucherBindingModel, DownloadGiftVoucherViewModel } from '../models/web-booking.models';
import { BaseService, RequestType } from './base.service';

@Injectable()
export class WebGiftVoucherService extends BaseService {

    ValidateUserToken(): Observable<boolean> {
        return this.sendRequest('api/WebGiftVoucher/validate-user-token', null);
    }

    CheckEmailStatus(model: CheckEmailStatusBindingModel): Observable<CheckEmailStatusViewModel> {
        return this.sendRequest('api/WebGiftVoucher/check-email', model);
    }

    GetProfile(model: any): Observable<Customer> {
        return this.sendRequest('api/WebGiftVoucher/get-profile', model, RequestType.Get);
    }

    Logout(): Observable<LogoutViewModel> {
        return this.sendRequest('api/WebGiftVoucher/logout', null);
    }

    SendMigrationLink(model: SendMigrationLinkBindingModel): Observable<SendMigrationLinkViewModel> {
        return this.sendRequest('api/WebGiftVoucher/send-migration-link', model);
    }

    SendEmailVerification(model: SendEmailVerificationBindingModel): Observable<SendEmailVerificationViewModel> {
        return this.sendRequest('api/WebGiftVoucher/send-email-verification', model);
    }

    SendPasswordResetKeyLinkToEmail(model: SendPasswordResetKeyLinkToEmailBindingModel):
     Observable<SendPasswordResetKeyLinkToEmailViewModel> {
        return this.sendRequest('api/WebGiftVoucher/send-password-reset-link-to-email', model);
    }

    GetHealthFunds(model: any): Observable<any[]> {
        return this.sendRequest('api/WebGiftVoucher/get-health-funds', model);
    }

    IsValidPasswordResetKey(model: IsValidPasswordResetKeyBindingModel): Observable<IsValidPasswordResetKeyViewModel> {
        return this.sendRequest('api/WebGiftVoucher/is-valid-password-reset-key', model);
    }

    ResetPassword(model: ResetPasswordBindingModel): Observable<ResetPasswordViewModel> {
        return this.sendRequest('api/WebGiftVoucher/reset-password', model);
    }

    RegisterCustomer(model: RegisterCustomerBindingModel): Observable<Customer> {
        return this.sendRequest('api/WebGiftVoucher/create-account', model);
    }

    UpdateDetails(model: UpdateDetailsBindingModel): Observable<UpdateDetailsViewModel> {
        return this.sendRequest('api/WebGiftVoucher/update-details', model);
    }

    SetPassword(model: ChangePasswordBindingModel): Observable<SetPasswordViewModel> {
        return this.sendRequest('api/WebGiftVoucher/set-password', model);
    }

    CustomerTransaction(model: CustomerTransactionBindingModel): Observable<CustomerTransaction> {
        return this.sendRequest('api/WebGiftVoucher/data', model);
    }

    IsValidMigrationKey(model: IsValidMigrationKeyBindingModel): Observable<IsValidMigrationKeyViewModel> {
        return this.sendRequest('api/WebGiftVoucher/is-valid-migrate-key', model);
    }

    MigrateCustomer(model: MigrateCustomerBindingModel): Observable<MigrateCustomerViewModel> {
        return this.sendRequest('api/WebGiftVoucher/migrate-customer', model);
    }

    UpdateCustomer(model: UpdateCustomerBindingModel): Observable<UpdateCustomerViewModel> {
        return this.sendRequest('api/WebGiftVoucher/update-customer', model);
    }

    ChangePassword(model: ChangePasswordBindingModel): Observable<boolean> {
        return this.sendRequest('api/WebGiftVoucher/change-password', model);
    }

    IsValidEmailVerificationkey(model: IsValidEmailVerificationKeyBindingModel): Observable<IsValidEmailVerificationkeyViewModel> {
        return this.sendRequest('api/WebGiftVoucher/is-valid-email-verification-key', model);
    }

    VerifyCustomerEmail(model: VerifyCustomerEmailBindingModel): Observable<VerifyCustomerEmailViewModel> {
        return this.sendRequest('api/WebGiftVoucher/verify-customer-email', model);
    }

    GetStates(): Observable<State[]> {
        return this.sendRequest('api/WebGiftVoucher/get-states', null, RequestType.Get);
    }

    GetCountries(): Observable<Country[]> {
        return this.sendRequest('api/WebGiftVoucher/get-countries', null, RequestType.Get);
    }

    GetLocations(): Observable<Branch[]> {
        return this.sendRequest('api/WebGiftVoucher/get-locations', null);
    }

    GetLocationById(model: any): Observable<Branch> {
        return this.sendRequest('api/WebGiftVoucher/get-location-by-id', model);
    }

    GetGiftVouchers(mode: any): Observable<any[]> {
        return this.sendRequest('api/WebGiftVoucher/get-gift-vouchers', mode);
    }

    CancelPendingTransaction(model: CancelPendingTransactionBindingModel, requestType?: RequestType): Observable<boolean> {
        return this.sendRequest('api/WebGiftVoucher/cancel-order', model, requestType);
    }

    ComputeOrder(model: ComputeOrderBindingModel): Observable<ComputeOrderViewModel> {
        return this.sendRequest('api/WebGiftVoucher/compute-order', model);
    }

    PlaceOrder(model: PlaceOrderBindingModel): Observable<PlaceOrderViewModel> {
        return this.sendRequest('api/WebGiftVoucher/place-order', model);
    }

    ValidateGiftVoucherByNumber(model: ValidateGiftVoucherByNumberBindingModel[]): Observable<any[]> {
        return this.sendRequest('api/WebGiftVoucher/validate-gift-voucher-number', model);
    }

    VerifyPendingTransaction(model: VerifyPendingTransactionBindingModel): Observable<boolean> {
        return this.sendRequest('api/WebGiftVoucher/verify-pending-transaction', model);
    }

    CommitPayment(model: any): Observable<CommitPaymentViewModel> {
        return this.sendRequest('api/WebGiftVoucher/commit-payment', model);
    }

    SetTransactionAsPaidOnline(model: any): Observable<any> {
        return this.sendRequest('api/WebGiftVoucher/set-transaction-as-paid-online', model);
    }

    SendTransactionToEmail(model: any): Observable<boolean> {
        return this.sendRequest('api/WebGiftVoucher/email-transaction-details', model);
    }

    GetAppointmentWebGiftVoucherProcessStatus(model: any, requestType?: RequestType): Observable<any> {
        return this.sendRequest('api/WebGiftVoucher/get-appointmet-booking-process-status', model, requestType);
    }

    AddLogs(model: any): Observable<boolean> {
        return this.sendRequest('api/WebGiftVoucher/add-logs', model);
    }
    
    DownloadGiftVoucher(model: DownloadGiftVoucherBindingModel): Observable<DownloadGiftVoucherViewModel> {
        return this.sendRequest('api/WebGiftVoucher/download-gift-voucher', model);
    }

    GetTransactionProcessStatus(model: any, requestType?: RequestType): Observable<any> {
        return this.sendRequest('api/WebGiftVoucher/get-transaction-process-status', model, requestType);
    }
}
